// extracted by mini-css-extract-plugin
export var skipAnimation = "_48-0";